window.theme = window.theme || {};
window.Shopify = window.Shopify || {};

theme.config = {
  bpSmall: false,
  hasSessionStorage: true,
  hasLocalStorage: true,
  mediaQuerySmall: 'screen and (max-width: '+ 769 +'px)',
  youTubeReady: false,
  vimeoReady: false,
  vimeoLoading: false,
  isTouch: ('ontouchstart' in window) || window.DocumentTouch && window.document instanceof DocumentTouch || window.navigator.maxTouchPoints || window.navigator.msMaxTouchPoints ? true : false,
  stickyHeader: false,
  rtl: document.documentElement.getAttribute('dir') == 'rtl' ? true : false
};
theme.recentlyViewedIds = [];

(function(){
  let phsp;
  if ( document.body.classList.contains('template-product') ) {
    // new theme.Sections();
    new theme.AjaxProduct();
    phsp = new theme.Photoswipe();
  }
  if ( document.getElementById('product-grid') ) {
    new theme.QuickAdd(document.getElementById('product-grid'));
  }

  let sliders = document.querySelectorAll('.grid-product-slider');
  if ( sliders ) {
    sliders.forEach((item) => {
      new theme.QuickAdd(item);
    });
  }

    $('#HeaderSearchTrigger').on('click', function(e) {
      e.preventDefault();
      let searchContainer = document.querySelector('.header-search-container');
      if ( searchContainer ) {
        searchContainer.classList.toggle('is-active');
        $('#HeaderSearchTrigger .icon-search-new').toggle()
        $('#HeaderSearchTrigger .icon-close-new').toggle()
        if ( searchContainer.classList.contains('is-active') ) {
          document.querySelector('.site-header__search-input').focus();
        } else {
          document.querySelector('.site-header__search-input').blur();
        }
      }
    })
  
   function loadRecentlyProducts(theme) {
      var recentIds = window.localStorage.getItem('recently-viewed');
      if (recentIds && typeof(recentIds) !== undefined) {
        theme.recentlyViewedIds = JSON.parse(recentIds);
      }

      // Stop if no data
      let container = document.querySelector('[data-section-type="recently-viewed"]');
      if (container && !theme.recentlyViewedIds.length) {
        container.classList.add('hide');
        return;
      }

      this.outputContainer = document.getElementById('RecentlyViewed');

      if ( !this.outputContainer ) return false;
      // var currentId = this.container.getAttribute('data-product-id');

      var url = '/search?view=recently-viewed&type=product&q=';

      var products = '';
      var i = 0;
     let maxProducts = 5;
      theme.recentlyViewedIds.forEach(function(val) {
        // Skip current product
        // if (val === currentId) {
        //   return;
        // }

        // Stop at max
        if (i >= maxProducts) {
          return;
        }

        products += 'id:' + val + ' OR ';
        i++;
      });

      url = url + encodeURIComponent(products);
     
      fetch(url).then(function(response) {
        return response.text();
      }).then(function(html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var count = doc.querySelectorAll('.product-grid').length;
        // let containerOut = document.getElementById('RecentlyViewed');
        if (count > 0) {
          var results = doc.querySelector('.product-grid');
          this.outputContainer.append(results);
          new theme.QuickAdd(this.outputContainer);
          container.classList.remove('hide');
        } else {
          this.outputContainer.classList.add('hide');
        }

    });
  }
  loadRecentlyProducts(theme);

  function setRecentlyProducts(theme) {
    var productCurrent = document.querySelector('[name="product-id"]');
    theme.recentlyViewedIds.forEach(function(val) {
      if (val === null ) {
        theme.recentlyViewedIds = [];
      }
    });
    if ( !productCurrent ) return false;
    let id = productCurrent.value;

    if (!id) return;

    // Remove current product if already in recently viewed array
    var i = theme.recentlyViewedIds.indexOf(id);
    if (i > -1) {
      theme.recentlyViewedIds.splice(i, 1);
    } 
    
    theme.recentlyViewedIds.unshift(id);
    if ( theme.recentlyViewedIds.length > 5 ) {
      theme.recentlyViewedIds.length = 5;
    }
    
    // theme.recentlyViewedIds = theme.recentlyViewedIds.slice(1,6);

    if (theme.config.hasLocalStorage) {
      window.localStorage.setItem('recently-viewed', JSON.stringify(theme.recentlyViewedIds));
    }
  }
  setRecentlyProducts(theme);


})();

(function($) {

  $(document).ready(function() {
    $('.remove-marketing-btn').on('click', removeFromMarketing)
    async function removeFromMarketing() {
      const customer_id = `gid://shopify/Customer/${window.currentCustomer.id}`
      fetch("https://dealcosmetics.myshopify.com/apps/webhooks-dev/ic2nipg6", {
        method: "POST",
        headers: {
        "Content-Type": "application/json"
      },
        body: JSON.stringify("{}")
      }).then(res => res.json()).then(data => {
        console.log(data);
      }).catch(err => {
        console.error(err);
      });
    }

    $('body').on('click', '.continue_shop', function(e) {
      e.preventDefault();
      $('.js-close-header-cart').trigger('click');
    });
    
    $('.faq_block_container .faq_title').on('click', function(e) {
      e.preventDefault();
      $(this).toggleClass('active');
    });
    
    $(document).on('Searchanise.DataRequestEnd', function(event, type, params, data) {
      let items = document.querySelector('.snize-ac-results-content');
      if ( items ) {
        items.setAttribute('data-products', JSON.stringify(data));
      }
    });

    $(document).on('scroll', function() {
      let searchPopupDisplay = $('.snize-ac-results').css('display');
      if ( searchPopupDisplay !== 'none' ) {
        $('.snize-ac-results').css('display', 'none');
      }
    });
    
    $(document).on('Searchanise.AutocompleteUpdated', async function(event, input, container) {
      let items = document.querySelectorAll('.snize-ac-results-content li.snize-product');
      let itemsContainer = document.querySelector('.snize-ac-results-content')
      let data = JSON.parse(itemsContainer.getAttribute('data-products'));
      
      if ( items ) {
        items.forEach( (item) => {
          item.classList.add('yahoooo');
          item.classList.remove('snize-ac-even');
          item.classList.remove('snize-ac-odd');

          const hasDiscount = !!item.querySelector('.snize-price-with-discount');
          if (hasDiscount) {
            const thumbnail = item.querySelector('.snize-thumbnail');

            const saleBadge = document.createElement('div');
            saleBadge.setAttribute('class', 'card__badge card-product-sale-badge bottom left');

            const saleBadgeText = document.createElement('span');
            saleBadge.setAttribute('class', 'badge badge--bottom-left color-background-1');
            saleBadgeText.innerText = 'Sale';

            saleBadge.appendChild(saleBadgeText);
            thumbnail.appendChild(saleBadge);
          }
          
          let itemID = item.getAttribute('id');
          let productID = itemID.slice(17); 
          let btnAdd = document.createElement('button');
          const variant = data.items.filter(v => v.product_id === productID);
          const handle = variant[0].link.substring(variant[0].link.lastIndexOf('/') + 1)
          item.classList.add('grid-product')
          item.setAttribute('data-product-handle', handle)
          item.setAttribute('data-product-id', variant[0].product_id)
          btnAdd.setAttribute('type', 'button');
          if (variant[0].shopify_variants.length > 1)
            btnAdd.setAttribute('class', 'add-to-cart add-to-cart-button quick-add-btn js-modal-open-quick-add js-quick-add-form');
          else
            btnAdd.setAttribute('class', 'add-to-cart add-to-cart-button quick-add-btn js-quick-add-btn');
          btnAdd.setAttribute('title', 'הוספה לסל')
          btnAdd.setAttribute('data-id', variant[0].add_to_cart_id);
          btnAdd.innerHTML = 'הוספה לסל<span class="btn"></span>';
          item.appendChild(btnAdd);
        
          //yotpo rating
          // let yotpoStars = document.createElement('div');
          // yotpoStars.setAttribute('class', 'yotpo bottomLine yotpo-small');
          // yotpoStars.setAttribute('data-product-id', productID);
          // let titleItem = item.querySelector('.snize-title');
          // console.log(titleItem);
          // titleItem.after(yotpoStars);
          
        }); 

        new theme.QuickAdd(document.querySelector('.snize-ac-results-content'));

        // var api = new Yotpo.API(yotpo);
        // api.refreshWidgets();
        // console.log(data);
      } 

      if ($('snize-no-products-found') && container.find('#flashy-cart-recommendations').length == 0) {
        const flashyHeading = `<li class="snize-label" style="list-style: none">אולי יעניין אותך</li>`
        const flashyInsert = `
          <div class="swiper-hp-flashy swiper empty-cart-swiper">
            <ul id="flashy-cart-recommendations" class="swiper-wrapper flashy-recommendations-mobile" role="list">
            </ul>
          </div>`;
          if (window.innerWidth <= 768)
            $('#snize-ac-items-container-4').after(flashyInsert);
          else
            $('.snize-ac-results-multicolumn-list').after(flashyInsert);
        await (new FlashyProductRecommendations(20394, 'flashy-cart-recommendations')).init();
        $('.empty-cart-swiper').before(flashyHeading)
      }
    });
    $('#search-close').on('click', function() {

      $('.site-header__search-input.snize-input-style').val('');

    });

    /**
     * change looks for product collection page
    */
    $('body').on('click', 'button[data-view]', function(e) {
      e.preventDefault();
      $('button[data-view]').removeClass('is-active');
      $(this).addClass('is-active');
      let view = $(this).attr('data-view');
      $('#product-grid').attr('data-view', view);
    })

    function setSlideHeight(that){
      $('.gallery-thumbs').css({height:'auto'});
      var currentSlide = that.activeIndex;
      var newHeight = $(that.slides[currentSlide]).height();

      $('.gallery-thumbs .swiper-wrapper,.gallery-thumbs .swiper-slide').css({ height : newHeight })
      that.update();
     }
    
    function isVideoPlay(that) {
      // console.log('isvideoplayer');
      if ( $('.gallery-main .swiper-slide-active .deferred-media__poster').length > 0 ) {
        $('.gallery-main .swiper-slide-active .deferred-media__poster').trigger('click');
      }
      if ( $('.gallery-main .swiper-slide-active video').length > 0 ) {
        let video = $('.gallery-main .swiper-slide-active video');
        
        try {
          video[0].play();
        } catch (error) {
          console.log(error);
        }
      }
    }
  var galleryThumbs, galleryMain;

  function initProductGallery() {
    try {
      let slides = $('.gallery-main .product__media-item');
      
      if (slides.length > 1) {
        const $galleryThumbs = $('.gallery-thumbs');
        const $galleryMain = $('.gallery-main');
        
        if ($galleryThumbs.length === 0) {
          console.warn('Gallery thumbs container not found in DOM');
          return;
        }
        
        if ($galleryMain.length === 0) {
          console.warn('Gallery main container not found in DOM');
          return;
        }
        
        const galleryThumbsElement = $galleryThumbs[0];
        const galleryMainElement = $galleryMain[0];
        
        if (!(galleryThumbsElement instanceof Element)) {
          console.error('Gallery thumbs is not a valid DOM element');
          return;
        }
        
        if (!(galleryMainElement instanceof Element)) {
          console.error('Gallery main is not a valid DOM element');
          return;
        }
        
        galleryThumbs = new Swiper(galleryThumbsElement, {
          slidesPerView: 5.3,
          watchOverflow: false,
          watchSlidesVisibility: true,
          watchSlidesProgress: true,
          direction: 'horizontal',
          initialSlide: 1,
          autoScrollOffset: 1,
          spaceBetween: 15,
          slideToClickedSlide: true,
          on: {
            init: function() {
              $('.swiper-container.gallery-thumbs').css({ display: 'block' });
            }
          }
        });
        
        galleryMain = new Swiper(galleryMainElement, {
          slidesPerView: 1,
          slideToClickedSlide: true,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          thumbs: {
            swiper: galleryThumbs
          },
          on: {
            slideChangeTransitionEnd: function() {
              if (typeof isVideoPlay === 'function') {
                isVideoPlay(this);
              }
            }
          }
        });
        
        if (galleryMain && galleryThumbs) {
          galleryMain.on('slideChangeTransitionStart', function() {
            if (galleryThumbs && !galleryThumbs.destroyed) {
              galleryThumbs.slideTo(galleryMain.activeIndex);
            }
          });
          
          galleryThumbs.on('transitionStart', function() {
            if (galleryMain && !galleryMain.destroyed) {
              galleryMain.slideTo(galleryThumbs.activeIndex);
            }
          });
        }
        
      } else {
        $('.gallery-thumbs .swiper-wrapper').removeClass('swiper-wrapper');
        $('.gallery-thumbs .swiper-button-prev').remove();
        $('.gallery-thumbs .swiper-button-next').remove();
        $('.gallery-thumbs .swiper-pagination').remove();
        $('.gallery-thumbs .swiper-container').removeClass('swiper-container');
      }
      
    } catch (error) {
      console.error('Error initializing product gallery:', error);
      
      if (galleryThumbs && typeof galleryThumbs.destroy === 'function') {
        try {
          galleryThumbs.destroy();
        } catch (e) {
          console.warn('Error destroying gallery thumbs:', e);
        }
        galleryThumbs = null;
      }
      
      if (galleryMain && typeof galleryMain.destroy === 'function') {
        try {
          galleryMain.destroy();
        } catch (e) {
          console.warn('Error destroying gallery main:', e);
        }
        galleryMain = null;
      }
    }
  }

  initProductGallery();

    // if ( $(window).width() <= 750 ) {
    //   if ( $('.gallery-main .product__media-item').length > 1 ) {
    //     galleryMain = new Swiper(".gallery-main", {
    //       // loop: true,
    //       loopedSlides: 3,
    //       slidesPerView: 1,
    //       spaceBetween: 10,
    //       centeredSlides: true,
    //       centeredSlidesBounds: true,
    //       slideToClickedSlide: true,
    //       navigation: {
    //         nextEl: '.swiper-button-next',
    //         prevEl: '.swiper-button-prev',
    //       },
    //       thumbs: {
    //         swiper: galleryThumbs
    //       },
    //       pagination: {
    //         el: '.swiper-pagination',
    //         type: 'bullets',
    //         clickable: true,
    //       },
    //       on:{
    //         slideChangeTransitionEnd:function(){
    //           isVideoPlay(this);
    //         }
    //       }
    //     });
    //   } else {
    //     $('.gallery-main .swiper-wrapper').removeClass('swiper-wrapper');
    //     $('.gallery-main.swiper-container').removeClass('swiper-container');
    //     $('.gallery-main .swiper-button-prev').remove();
    //     $('.gallery-main .swiper-button-next').remove();
    //     $('.gallery-main .swiper-pagination').remove();
    //   }
    // }

    if ( $('.template-product [name="Color"]:checked').length > 0 ) {
      let currentVariant = $('[name="Color"]:checked').val();
      $('variant-radios .product-form__input .current_color').text(currentVariant);
    }

    /**
    * code for change slides in product slide for each variant
    */
    let productCur = $('[data-tb-variants-json]').attr('data-tb-variants-json');
    if (productCur) {
      productCur = JSON.parse(productCur);
    }

    function variantImage(val) {
      var selectedVariantId = val;
      const variant = productCur.filter(v => v.title === selectedVariantId);

      if ( $('[date-for-slick]').length > 1 && $('[date-for-slick="' + variant[0].featured_media.id + '"]').length > 0 ) {
        activeMedia = document.querySelector(`[date-for-slick="${variant[0].featured_media.id}"]`).getAttribute('aria-label');
        var numbers = activeMedia.split("/");
        var firstNumber = parseInt(numbers[0]);
        galleryMain.slideTo(firstNumber - 1);
        galleryMain.slideTo(firstNumber - 1);
      }
    }


    $('body').on('change', '[name="size"]', function() {
      var selectedVariantId = $(this).val();
      variantImage(selectedVariantId);
    });

    function getCurrentVariant() {
      let variantObject = document.querySelector("[data-tb-variants-json]");
      variantObject = JSON.parse(
          variantObject.getAttribute("data-tb-variants-json")
      );
      let currentVariantId = document.querySelector(
          ".product-variant-id"
      ).value;
      const variant = variantObject.filter(
          (v) => v.id === parseInt(currentVariantId, 10)
      );
      return variant;
  }

  function variantImage(val) {
    const variant = productCur.filter(v => v.title === val);
    if (!variant[0] || !variant[0].featured_media) return;

    var mediaId = variant[0].featured_media.id;
    var thumb = document.querySelector('.simple-gallery__thumb[data-media-id="' + mediaId + '"]');

    if (thumb) {
      thumb.click();

      var thumbsWrap = thumb.closest('.simple-gallery__thumbs');
      if (thumbsWrap) {
        var wrapRect = thumbsWrap.getBoundingClientRect();
        var thumbRect = thumb.getBoundingClientRect();

        if (thumbRect.left < wrapRect.left) {
          // thumb is cut off on the left — scroll left by the difference
          thumbsWrap.scrollBy({ left: thumbRect.left - wrapRect.left, behavior: 'smooth' });
        } else if (thumbRect.right > wrapRect.right) {
          // thumb is cut off on the right — scroll right by the difference
          thumbsWrap.scrollBy({ left: thumbRect.right - wrapRect.right, behavior: 'smooth' });
        }
        // if it's already fully visible, do nothing
      }
    } else {
      var mainImg = document.querySelector('.simple-gallery__main img');
      if (mainImg && variant[0].featured_image) {
        mainImg.src = variant[0].featured_image.src;
      }
    }
  }

    function setSku() {
      let currentVariant = getCurrentVariant();
      let sku = document.querySelector("product-info [data-sku-id]");
      sku.innerHTML = currentVariant[0].sku;
    }

    $('body').on('change', '[name="Color"]', function() {
      let currentVariant = $(this).closest('variant-radios').find('[name="Color"]:checked').val();
      $(this).closest('variant-radios').find('.product-form__input .current_color').text(currentVariant);
      var selectedVariantId = $(this).val();
      variantImage(selectedVariantId);
      setSku();
    });

    $('body').on('change', '[name="color"]', function() {
      let currentVariant = $(this).closest('variant-radios').find('[name="color"]:checked').val();
      $(this).closest('variant-radios').find('.product-form__input .current_color').text(currentVariant);
      var selectedVariantId = $(this).val();
      variantImage(selectedVariantId);
      setSku(productCur);
    });

    $('body').on('change', '[name*="color"]', function() {
      let currentVariant = $(this).closest('.variant-radios').find('[name*="color"]:checked').val();
      $(this).closest('.variant-radios').find('.product-form__input .current_color').text(currentVariant);
      var selectedVariantId = $(this).val();
      variantImage(selectedVariantId);
      setSku(productCur);
    });
    
    $('body').on('change', '[name*="Color"]', function() {
      let currentVariant = $(this).closest('.variant-radios').find('[name*="Color"]:checked').val();
      $(this).closest('.variant-radios').find('.product-form__input .current_color').text(currentVariant);
      var selectedVariantId = $(this).val();
      variantImage(selectedVariantId);
      setSku(productCur);
    });

    let variatn = $('[name="Color"]:checked');
    if ( variatn.length > 0 ) {
      var selectedVariantId = variatn.val();
      variantImage(selectedVariantId);
    }

    let variatn1 = $('[name="color"]:checked');
    if ( variatn1.length > 0 ) {
      var selectedVariantId = variatn.val();
      variantImage(selectedVariantId);
    }

    /**
    * code for toggle sorting in mobile filter
    */
    $('.mobile-facets__sort .label_box').on('click', function(e) {
      if ( $(window).width() > 750 ) return false;
      e.preventDefault();
      $(this).closest('.mobile-facets__sort').toggleClass('active');
    });

    let scrolledHeader = $('#SiteHeader').innerHeight();

    if ( $(window).width() < 750 && $('.facets-vertical .facets-wrapper').length > 0 ) {
      $('.facets-vertical .facets-wrapper').css('top', scrolledHeader);
    }
    if ( $(window).width() < 750 && $('.facets-vertical .facets-wrapper').length > 0 && $('menu-drawer.mobile-facets__wrapper').length > 0 ) {
      let scrolledHeaderFilter = $('menu-drawer.mobile-facets__wrapper').innerHeight() + scrolledHeader;
      let activeFiltersHeight;
      if ( $('.active-facets.active-facets-mobile facet-remove').length > 0 ) {
        activeFiltersHeight = $('.active-facets.active-facets-mobile').innerHeight();
        scrolledHeaderFilter += activeFiltersHeight;
      }
      $('#FacetFiltersFormMobile').css('top', scrolledHeaderFilter);
    }

    $('.facets__disclosure-vertical').on('click', function() {
      var clickedElement = this;
    
      $('.facets__disclosure-vertical').each(function() {
        if (this !== clickedElement) { 
          $(this).removeAttr('open'); 
          $(this).find('summary').attr('aria-expanded', 'false')
        }
      });
    });

    function checkLenghtDesc() {
      let desc = $('#collection-description-boa');
      desc.css('display', 'block');
      if ( desc.find('> .enlarge-text').innerHeight() > 63 ) {
        desc.css('display', '-webkit-box');
      } else {
        $('#collection-show-description').hide();
      }
    }
    checkLenghtDesc();

    $('.explaination').on('click', function(e) {
      e.preventDefault();
      let heightExp = $(this).find('.explanation_content');
      heightExp.css('bottom', -heightExp.innerHeight() - 10 );
      $(this).toggleClass('active');
    })

    /**
    * change images in loop on hover
    */
    $('.grid-product__colors .color-swatch').on('mouseover', function() {
      let curImage = $(this).attr('data-variant-image');
      $(this).closest('.grid-product').find('.color_variant_img.grid-product__color-image').css('backgroundImage', `url(${curImage})`).addClass('is-active');
    })
    $('.grid-product__colors .color-swatch').on('mouseleave', function() {
      let curImage = $(this).attr('data-variant-image');
      $(this).closest('.grid-product').find('.color_variant_img.grid-product__color-image').css('backgroundImage', '').removeClass('is-active');
    })
    $('.grid-product__colors .color-swatch').on('click', function(e) {
      e.preventDefault();
      let newHref = $(this).closest('.grid-product').find('.full-unstyled-link').attr('href');
      window.location.href = newHref;
    });

    // if ($('.yotpo-reviews').length > 0) {
      // $('.yotpo-reviews').slick();
    // }
    
  })
})(window.jQuery)


